import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import OnboardingModal from "../components/OnboardingModal";

const OnboardingPage = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;

    if (!user) {
      navigate("/login", { replace: true });
      return;
    }

    if (!user.is_first_login) {
      navigate("/", { replace: true });
    }
  }, [loading, navigate, user]);

  if (loading || !user) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen gap-4">
        <div className="w-12 h-12 border-4 border-chafadi-primary border-t-transparent rounded-full animate-spin" />
        <p className="text-theme-muted font-bold animate-pulse">Initializing Setup...</p>
      </div>
    );
  }

  return (
    <OnboardingModal
      show={true}
      onHide={() => navigate("/", { replace: true })}
    />
  );
};

export default OnboardingPage;
